/**
 * Created by hj on 2017/8/17.
 */
import React from 'react';
import { DmsTab, RegionCascader } from 'Components';
import {Button, Tabs, Table, Modal, Select, Input, Switch, DatePicker, Cascader} from 'antd';
const TabPane = Tabs.TabPane;
const Option = Select.Option;
import { openNotice, formatMoney } from 'Utils';
import moment from 'moment';
import { getReturnOrderDetails, returnOrderApprove, returnOrderConfirmCollect, returnOrderSendSave, getSendProduct, getWarehouseList, returnOrderConfirmAmount } from '../../service/returnOrder';
import { getOrderLog, getStorageAvailable } from '../../service/order';
import { getDictionay } from '../../service/product';

class returnOrderDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['订单详情'],
			defaultActiveKey: 1,
			detailData: {
				'returnChannelDelivery': {}
			},
			logisticsArr: [], /* 物流公司 */
			loadingSend: false,
			visibleSend: false,
			sendData: {
				'orderDeliveryItemList': [],
				'logisticsCompany': '',
				'logisticsCode': ''
			},
			loadingApprove: false,
			visibleApprove: false,
			approveData: {
				'id': '',
				'status': 1,
				'returnDelivery': {
					'province': '',
					'city': '',
					'county': ''
				},
				'address': '',
				'mobile': '',
				'receiver': '',
				'remark': ''
			},
			/* 确认收货 */
			visibleConfirmCollect: false,
			loadingConfirmCollect: false,
			confirmCollectData: {
				'returnNum': '',
				'deliveryNum': '',
				'id': '',
				'orderReturnId': '',
				'warehouseArr': [],
				'receiverDate': moment().format('YYYY-MM-DD')
			},
			warehouseList: [],
			returnAmountVisible: false
		}
	}

	initData () {
		let orderId = this.props.routeParams.orderId;
		let self = this;
		getReturnOrderDetails(orderId).then(result => {
			if (result && result.code == 200) {
				let detailData = result.data.orderReturn || {};
				detailData.returnData = detailData.sellerStatus > 2 ? detailData.returnItemList : []
				detailData.orderRecord = [];
				detailData.returnChannelDelivery = detailData.returnChannelDelivery || {};
				self.setState({
					'detailData': detailData
				});
				getOrderLog(orderId, 2).then(function (logResult) {
					if (logResult && logResult.code == 200) {
						logResult = logResult.data || [];
						if (detailData.sellerStatus == 6 || detailData.sellerStatus == 7) {
							// 已取消 已完成
						} else {
							logResult.push({
								'operation': detailData.sellerStatusText,
								'createdDate': ''
							});
						}
						self.setState({
							'detailData': {
								...self.state.detailData,
								'orderRecord': logResult
							}
						});
					} else {
						openNotice('error', '订单日志获取失败', (logResult && logResult.message) ? logResult.message : '');
					}
				});
			} else {
				openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
				setTimeout(() => {
					window.history.go(-1);
				}, 100);
			}
		});
	}

	componentDidMount () {
		this.initData();
		let self = this;
		getDictionay('express_company').then(function (result) {
			if (result && result.code == 200) {
				self.setState({
					logisticsArr: result.data || []
				});
			} else {
				openNotice('error', '物流公司获取失败', (result && result.message) ? result.message : '');
			}
		});
		getWarehouseList().then(result => {
			if (result && result.code == 200) {
				self.setState({
					warehouseList: result.data || []
				});
			} else {
				openNotice('error', '仓库数据获取失败', (result && result.message) ? result.message : '');
			}
		});
	}

	backTo() {
		window.history.go(-1);
	}

	tabClickFn(key) {
		/* 页签点击 */
		this.setState({defaultActiveKey: key});
	}

	showModal = () => {
		/* 显示发货页面 */
		let orderId = this.props.routeParams.orderId;
		let self = this;
		getSendProduct(orderId).then(function (result) {
			if (result && result.code == 200) {
				let resultData = result.data || [];
				for (let send of resultData.productList) {
					send.storageLocal = [];
					send.count = 0; // 发货数量 默认0
					send.availableCount = 0;
				}
				self.setState({
					visibleSend: true,
					sendData: {
						...self.state.sendData,
						'orderDeliveryItemList': resultData.productList || [],
						'code': resultData.code,
						'logisticsCompany': '',
						'logisticsCode': ''
					}
				});
			} else {
				openNotice('error', '数据获取失败', '');
			}
		});
	}
	handleSendOk = () => {
		this.setState({loadingSend: true});
		const { sendData, detailData } = this.state;
		let self = this;
		let params = {
			'orderDeliveryItemList': [],
			'code': sendData.code,
			'orderId': detailData.id,
			'logisticsCompany': sendData.logisticsCompany,
			'logisticsCode': sendData.logisticsCode
		};
		let orderDeliveryItemList = sendData.orderDeliveryItemList || [];
		for (let delivery of orderDeliveryItemList) {
			let storageLocal = delivery.storageLocal || [];
			if (delivery.count > 0 && storageLocal.length > 0) {
				params.orderDeliveryItemList.push({
					'storageId': storageLocal[0], /* 仓库ID */
					'storageLocalId': storageLocal.length == 2 ? storageLocal[1] : '', /* 货位 */
					'orderId': delivery.orderId,
					'productId': delivery.productId,
					'orderProductId': delivery.id,
					'count': delivery.count /* 发货数量 */
				});
			}
		}
		if (params.orderDeliveryItemList.length == 0) {
			openNotice('warning', '验证', '请选择仓库-货位,请输入发货数量');
			return;
		}
		returnOrderSendSave(params).then(function (result) {
			if (result && result.code == 200) {
				self.setState({loadingSend: false, visibleSend: false});
				self.initData(1);
				openNotice('success', '发货操作成功', '');
			} else {
				self.setState({loadingSend: false});
				openNotice('error', '发货操作失败', (result && result.message) ? result.message : '');
			}
		});
	}
	handleSendCancel = () => {
		this.setState({visibleSend: false, loadingSend: false});
	}
	changeInputSendFn (index, field, value) {
		let val = value;
		let self = this;
		if (value.target) {
			val = value.target.value || '';
		}
		if (index == -1) {
			this.setState({
				'sendData': {
					...this.state.sendData,
					[field]: val
				}
			});
			return;
		}
		let orderDeliveryItemList = this.state.sendData.orderDeliveryItemList || [];
		if (field == 'count') {
			if (!orderDeliveryItemList[index].availableCount || orderDeliveryItemList[index].availableCount == 0) {
				openNotice('warning', '验证', '请选择仓库-货位！');
				return;
			}
			if (orderDeliveryItemList[index].availableCount < val) {
				val = orderDeliveryItemList[index].availableCount;
			}
			if (orderDeliveryItemList[index].undeliveredCount < val) {
				val = orderDeliveryItemList[index].undeliveredCount;
			}
		}
		orderDeliveryItemList[index][field] = val;
		if (field == 'storageLocal' && val.length > 0) {
			let params = {
				'productId': orderDeliveryItemList[index].productId,
				'productSpecId': orderDeliveryItemList[index].productSpecId,
				'storage': val[0],
				'storageLocal': val.length > 1 ? val[1] : ''
			};
			getStorageAvailable(params).then(result => {
				if (result && result.code == 200) {
					let availableCount = result.data || 0;
					if (availableCount == 0) {
						orderDeliveryItemList[index][field] = [];
						openNotice('warning', '验证', '该仓库-货位上没有该产品，请重新选择！');
					}
					if (availableCount < orderDeliveryItemList[index]['count']) {
						openNotice('warning', '验证', '该仓库-货位上的产品库存小于发货数量！');
						orderDeliveryItemList[index]['count'] = availableCount;
					}
					orderDeliveryItemList[index]['availableCount'] = availableCount;
					self.setState({
						'sendData': {
							...this.state.sendData,
							'orderDeliveryItemList': orderDeliveryItemList
						}
					});
				}
			});
		} else {
			this.setState({
				'sendData': {
					...this.state.sendData,
					'orderDeliveryItemList': orderDeliveryItemList
				}
			});
		}
	}

	showApproveModal () {
		this.setState({
			visibleApprove: true,
			approveData: {
				'id': this.state.detailData.id,
				'status': 1,
				'returnDelivery': {
					'province': '',
					'city': '',
					'county': ''
				},
				'address': '',
				'mobile': '',
				'receiver': '',
				'remark': ''
			}
		});
	}
	handleApproveOk = () => {
		let self = this;
		self.setState({loadingApprove: true});
		let params = self.state.approveData;
		if (params.status) {
			// 审核通过验证
			if (!params.receiver) {
				openNotice('warning', '请输入收件人', '');
				self.setState({loadingApprove: false});
				return;
			}
			if (!params.mobile) {
				openNotice('warning', '请输入联系电话', '');
				self.setState({loadingApprove: false});
				return;
			}
			if (!params.returnDelivery.province) {
				openNotice('warning', '请选择所在地区-省', '');
				self.setState({loadingApprove: false});
				return;
			}
			if (!params.returnDelivery.city) {
				openNotice('warning', '请选择所在地区-市', '');
				self.setState({loadingApprove: false});
				return;
			}
			if (!params.returnDelivery.county) {
				openNotice('warning', '请选择所在地区-区', '');
				self.setState({loadingApprove: false});
				return;
			}
			if (!params.address) {
				openNotice('warning', '请输入详细地址', '');
				self.setState({loadingApprove: false});
				return;
			}
			params.returnDelivery.address = params.address;
			params.returnDelivery.receiver = params.receiver;
			params.returnDelivery.mobile = params.mobile;
		} else {
			params.returnDelivery = {};
		}
		params.auditStatus = params.status ? 1 : 2;
		returnOrderApprove(params).then(result => {
			self.setState({loadingApprove: false});
			if (result && result.code == '200') {
				self.setState({visibleApprove: false});
				self.initData();
			} else {
				openNotice('error', '审核操作失败', (result && result.message) ? result.message : '');
			}
		});
	}
	handleApproveCancel = () => {
		this.setState({visibleApprove: false});
	}
	changeApproveFn (field, value) {
		if (field == 'returnDelivery') {
			value = value.value;
		} else {
			value = typeof value == 'object' ? value.target.value : value;
		}
		this.setState({
			'approveData': {
				...this.state.approveData,
				[field]: value
			}
		});
	}

	showConfirmCollectModal (item) {
		this.setState({
			visibleConfirmCollect: true,
			confirmCollectData: {
				'returnNum': item.returnNum - item.deliveryNum,
				'deliveryNum': '',
				'id': item.id,
				'orderReturnId': this.state.detailData.id,
				'receiverDate': ''
			}
		});
	}
	handleConfirmCollectOk = () => {
		let self = this;
		self.setState({loadingConfirmCollect: true});
		let params = self.state.confirmCollectData;
		if (!params.warehouseArr || params.warehouseArr.length == 0) {
			openNotice('warning', '请选择仓库-货位', '');
			self.setState({loadingConfirmCollect: false});
			return;
		}
		if (!params.deliveryNum) {
			openNotice('warning', '请输入实收数量', '');
			self.setState({loadingConfirmCollect: false});
			return;
		}
		params.receiverDate = params.receiverDate ? params.receiverDate : moment().format('YYYY-MM-DD');
		params.storageId = params.warehouseArr[0];
		if (params.warehouseArr.length > 1) {
			params.storageLocalId = params.warehouseArr[1];
		}
		returnOrderConfirmCollect(params).then(result => {
			self.setState({loadingConfirmCollect: false});
			if (result && result.code == '200') {
				self.setState({visibleConfirmCollect: false});
				self.initData();
			} else {
				openNotice('error', '确认收货操作失败', (result && result.message) ? result.message : '');
			}
		});
	}
	handleConfirmCollectCancel = () => {
		this.setState({visibleConfirmCollect: false});
	}
	changeConfirmCollectFn (field, value) {
		let val = '';
		if (field == 'deliveryNum') {
			val = value.target.value;
			if (val > this.state.confirmCollectData.returnNum) {
				val = this.state.confirmCollectData.returnNum;
			}
		} else if (field == 'receiverDate') {
			val = moment(value).format('YYYY-MM-DD');
		} else {
			val = value;
		}
		this.setState({
			'confirmCollectData': {
				...this.state.confirmCollectData,
				[field]: val
			}
		});
	}

	getAmount () {
		const { detailData } = this.state;
		let products = detailData.returnItemList || [];
		let amount = 0;
		for (let product of products) {
			amount += product.price * product.returnNum;
		}
		return formatMoney(amount);
	}

	returnDeliveryFn () {
		const { detailData }  = this.state;
		if (detailData.orderType == 2) {
			// 换货 -
			if (detailData.sellerStatus == 4) {
				// 待品牌商发货
				return true;
			}
			if (detailData.sellerStatus == 5 && detailData.undeliveredList.length > 0) {
				// 待渠道商收货, 当前订单还是商品未发货
				return true;
			}
		}
		return false;
	}

	confirmAmountFn () {
		// 确认退款
		this.setState({
			'returnAmountVisible': true
		});
	}
	handleReturnAmountOk () {
		// 确认退款
		this.setState({
			'returnAmountVisible': false
		});
		const { detailData } = this.state;
		let self = this;
		returnOrderConfirmAmount({'id': detailData.id}).then(result => {
			if (result && result.code == '200') {
				self.initData();
			} else {
				openNotice('error', '确认退款操作失败', (result && result.message) ? result.message : '');
			}
		});
	}
	handleReturnAmountCancel () {
		this.setState({
			'returnAmountVisible': false
		});
	}

	render() {
		const {opts, detailData, defaultActiveKey, visibleApprove, loadingApprove, approveData, visibleConfirmCollect, loadingConfirmCollect, confirmCollectData, visibleSend, loadingSend, sendData, logisticsArr } = this.state;
		let self = this;
		const productProps = {
			rowKey: 'id',
			columns: [
				{
					title: '产品名称',
					dataIndex: 'productName'
				}, {
					title: '规格',
					dataIndex: 'specUnionKey'
				}, {
					title: '单位',
					dataIndex: 'unitId'
				}, {
					title: '单价(元)',
					dataIndex: 'price'
				}, {
					title: '原订单',
					dataIndex: 'oldOrderCode'
				}, {
					title: '数量',
					dataIndex: 'returnNum'
				}, {
					title: '金额小计(元)',
					dataIndex: 'id',
					render: (text, record, index) => {
						return <span style={{color: '#d61518'}}>{'-' + formatMoney(record.price * record.returnNum)}</span>
					}
				}
			],
			dataSource: detailData.returnItemList || []
		};
		const returnProps = {
			rowKey: 'id',
			columns: [
				{
					title: '产品名称',
					dataIndex: 'productName'
				}, {
					title: '规格',
					dataIndex: 'specUnionKey'
				}, {
					title: '单位',
					dataIndex: 'unitId'
				}, {
					title: '退货数量',
					dataIndex: 'returnNum'
				}, {
					title: '实收数量',
					dataIndex: 'deliveryNum',
					render: text => <span>{text || 0}</span>
				}, {
					title: '操作',
					dataIndex: 'id',
					render: (text, record, index) => {
						if (record.returnNum > record.deliveryNum) {
							return <a onClick={self.showConfirmCollectModal.bind(self, record)}>确认收货</a>
						} else {
							return '';
						}
					}
				}
			],
			dataSource: detailData.returnData || []
		};
		const shippedProps = {
			rowKey: 'id',
			columns: [
				{
					title: '产品名称',
					dataIndex: 'productName'
				}, {
					title: '规格',
					dataIndex: 'specUnionKey'
				}, {
					title: '单位',
					dataIndex: 'unitId'
				}, {
					title: '待发数量/订单数量',
					dataIndex: 'id',
					render: (text, record, index) => {
						return <span>{`${record.undeliveredCount}/${record.deliveryNum || 0}`}</span>
					}
				}, {
					title: '待发金额',
					dataIndex: 'price',
					render: (text, record, index) => {
						return <span style={{color: '#d61518'}}>{formatMoney(record.undeliveredCount * text)}</span>
					}
				}
			],
			dataSource: detailData.undeliveredList || []
		};
		const stayProps = {
			rowKey: 'id',
			columns: [
				{
					title: '产品名称',
					dataIndex: 'productName'
				}, {
					title: '规格',
					dataIndex: 'productSpec'
				}, {
					title: '单位',
					dataIndex: 'unit'
				}, {
					title: '发货数量',
					dataIndex: 'count'
				}, {
					title: '发货仓库',
					dataIndex: 'storage'
				}, {
					title: '发运单号',
					dataIndex: 'orderDeliveryCode'
				}, {
					title: '发货日期',
					dataIndex: 'deliverDate'
				}, {
					title: '收货日期',
					dataIndex: 'receiveDate'
				}
			],
			dataSource: detailData.deliveredList || []
		};
		const sendProps = {
			rowKey: 'id',
			columns: [
				{
					title: '产品名称',
					dataIndex: 'productName'
				}, {
					title: '规格',
					dataIndex: 'specUnionKey'
				}, {
					title: '单位',
					dataIndex: 'unit'
				}, {
					title: '待发数量',
					dataIndex: 'undeliveredCount'
				}, {
					title: '发货仓库-货位',
					dataIndex: 'storageLocal',
					render: (text, record, index) => {
						return <div id={'storageLocal' + index}>
							<Cascader getPopupContainer={() => document.getElementById('storageLocal' + index)} value={text} onChange={this.changeInputSendFn.bind(this, index, 'storageLocal')} options={record.storageList || []} placeholder="请选择仓库-货位" />
						</div>
					}
				}, {
					title: '可用量',
					dataIndex: 'availableCount'
				}, {
					title: '发货数量',
					dataIndex: 'count',
					render: (text, record, index) => {
						return <Input type="number" value={text} onChange={this.changeInputSendFn.bind(this, index, 'count')} placeholder="请输入发货数量" />
					}
				}
			],
			dataSource: sendData.orderDeliveryItemList || []
		};
		let orderRecordHtml = (detailData.orderRecord || []).map(function (qst, key) {
			return <a className={(key==(detailData.orderRecord.length-1)  && !(detailData.sellerStatus==6 || detailData.sellerStatus==7))?'':'already'} key={key}>
				<p className="index"><span>{key + 1}</span></p>
				<p className="f">{qst.operation}</p>
				<p className={qst.createdDate.length>0?'':'no'}>{qst.createdDate || '-'}</p>
				<span style={{display: key==(detailData.orderRecord.length-1)?'none':'inline-block'}} className="l"></span>
			</a>
		});
		let deliveryHtml = function () {
			let returnDelivery = detailData.returnDelivery;
			if (!returnDelivery) {
				return '';
			}
			return (
				<div style={{borderTop: '1px solid #ddd'}}>
					<DmsTab className="white-bg no-border" options={['退货信息']} defaultKey={0}></DmsTab>
					<div className="com_detail">
						<div>
							<p><label>退货方式</label><span>{detailData.returnDelivery.deliverWayText}</span></p>
							<p><label>物流单号</label><span>{detailData.returnDelivery.expressNo}</span></p>
						</div>
						<div>
							<p><label>物流公司</label><span>{detailData.returnDelivery.expressCompanyText}</span></p>
							<p><label>备注留言</label><span>{detailData.returnDelivery.remark}</span></p>
						</div>
					</div>
				</div>
			)
		};
		let channelDeliveryHtml = function () {
			if (detailData.orderType == 1 || !detailData.returnChannelDelivery) {
				return '';
			}
			return (
				<div style={{borderTop: '1px solid #ddd'}}>
					<DmsTab className="white-bg no-border" options={['收(换)货人信息']} defaultKey={0}></DmsTab>
					<div className="com_detail">
						<div>
							<p><label>收货人</label><span>{detailData.returnChannelDelivery.receiver} {detailData.returnChannelDelivery.mobile}</span></p>
						</div>
						<div>
							<p><label>收货地址</label><span>{detailData.returnChannelDelivery.address}</span></p>
						</div>
					</div>
				</div>
			);
		};
		let logisticsHtml = logisticsArr.map(function (qst, key) {
			return <Option key={key} value={qst.sKey}>{qst.name}</Option>;
		});
		let sendHtml = function () {
			let flag = false;
			if (detailData.orderType == 2 && detailData.sellerStatus == 6) {
				// 退货
				flag = true;
			}
			if (detailData.sellerStatus == 4 || detailData.sellerStatus == 5) {
				// 待审核\待退货\待厂商收货\已取消
				flag = true;
			}
			if (!flag) {
				return '';
			}
			return (
				<TabPane tab="发货记录" key="3">
					<div>
						<DmsTab className="white-bg no-border" options={['待发货']} defaultKey={0}></DmsTab>
						<div className="dms-table-box">
							<Table {...shippedProps} bordered pagination={false}/>
						</div>
					</div>
					<div>
						<DmsTab className="white-bg no-border" options={['已发货']} defaultKey={0}></DmsTab>
						<div className="dms-table-box">
							<Table {...stayProps} bordered pagination={false}/>
						</div>
					</div>
				</TabPane>
			);
		};
		return <div>
			<DmsTab options={opts} defaultKey={0}>
				<Button style={{background:'#d61518', color: '#fff',display: detailData.sellerStatus==1?'inline-block': 'none'}} onClick={self.showApproveModal.bind(self)}>审核</Button>
				<Button style={{background:'#d61518', color: '#fff',display: detailData.sellerStatus==8?'inline-block': 'none'}} onClick={self.confirmAmountFn.bind(self)}>确认退款</Button>
				<Button style={{background:'#d61518', color: '#fff',display: this.returnDeliveryFn()?'inline-block': 'none'}} onClick={self.showModal.bind(self)}>发货</Button>
				<Button onClick={this.backTo.bind(this)}>返回</Button>
			</DmsTab>
			<div className="dms-table-box" style={{padding: '0'}}>
				<div className="order_detail">
					<div className="infor">
						<a>
							<p><label>订单编号</label><span>{detailData.code}</span></p>
							<p><label>客户名称</label><span>{detailData.customerName}</span></p>
							<p><label>所属区域</label><span>{detailData.areaText}</span></p>
							<span className="l"></span>
						</a>
						<a>
							<p><label>总金额</label><span className="pr">¥{detailData.amount}</span></p>
							<p><label>联系人</label><span>{detailData.contacts}</span></p>
							<p><label>订单状态</label><span>{detailData.sellerStatusText}</span></p>
							<span className="l"></span>
						</a>
						<a>
							<p><label>申请时间</label><span>{moment(detailData.createdDate).format('YYYY-MM-DD HH:mm:ss')}</span></p>
							<p><label>联系电话</label><span>{detailData.phone}</span></p>
							<p style={{color: '#fafafa'}}>1</p>
							<span className="l"></span>
						</a>
						<a>
							<p><label>最后更新</label><span>{moment(detailData.lastUpdatedDate).format('YYYY-MM-DD HH:mm:ss')}</span></p>
							<p><label>订单类型</label><span>{detailData.orderTypeText}</span></p>
							<p style={{color: '#fafafa'}}>1</p>
						</a>
					</div>
					<div className="opt">
						{orderRecordHtml}
					</div>
				</div>
				<div className="tab_individual order_other">
					<Tabs defaultActiveKey={defaultActiveKey + ''} onChange={self.tabClickFn.bind(self)}>
						<TabPane tab="订单详情" key="1">
							<div>
								<DmsTab className="white-bg no-border" options={['订单详情']} defaultKey={0}></DmsTab>
								<div className="dms-table-box">
									<Table {...productProps} bordered pagination={false}/>
								</div>
								<div className="order_amount">
									<p><span className="right">订单实际金额：<font>-¥{this.getAmount()}</font></span></p>
								</div>
							</div>
							{deliveryHtml()}
							{channelDeliveryHtml()}
						</TabPane>
						<TabPane tab="退货记录" key="2" disabled={detailData.status==1?true:false}>
							<div>
								<div className="dms-table-box">
									<Table {...returnProps} bordered pagination={false}/>
								</div>
							</div>
						</TabPane>
						{sendHtml()}
					</Tabs>
					<div className="line-b"></div>
					<div className="line-c" style={{left: ((defaultActiveKey - 1) * 150 + 10) + 'px'}}></div>
				</div>
			</div>
			<Modal
				visible={visibleSend}
				title="创建发货单"
				onOk={this.handleSendOk.bind(this)}
				onCancel={this.handleSendCancel.bind(this)}
				width = {'80%'}
				footer={[
            <Button key="back" size="large" onClick={self.handleSendCancel.bind(this)}>取消</Button>,
            <Button key="submit" type="primary" size="large" loading={loadingSend} onClick={self.handleSendOk.bind(this)}>
              确认发货
            </Button>
          ]}
			>
				<div>
					<DmsTab className="white-bg no-border" options={['发货单信息']} defaultKey={0}></DmsTab>
					<div className="com_detail">
						<div>
							<p><label>发货单</label><span>{sendData.code}</span></p>
							<p><label>客户名称</label><span>{detailData.customerName}</span></p>
							<p><label>收货人</label><span>{detailData.returnChannelDelivery.receiver} {detailData.returnChannelDelivery.mobile}</span></p>
						</div>
						<div>
							<p><label>订单编号</label><span>{detailData.code}</span></p>
							<p><label>配送方式</label><span>{detailData.returnChannelDelivery.deliverWayText || '快递'}</span></p>
							<p><label>收货地址</label><span>{detailData.returnChannelDelivery.address}</span></p>
						</div>
					</div>
				</div>
				<div style={{borderTop: '1px solid #ddd'}}>
					<DmsTab className="white-bg no-border" options={['发货清单']} defaultKey={0}></DmsTab>
					<div className="dms-table-box">
						<Table {...sendProps} bordered pagination={false}/>
					</div>
				</div>
				<div style={{borderTop: '1px solid #ddd'}}>
					<DmsTab className="white-bg no-border" options={['物流信息']} defaultKey={0}></DmsTab>
					<div className="com_detail">
						<div>
							<Select value={sendData.logisticsCompany} onChange={this.changeInputSendFn.bind(this, -1, 'logisticsCompany')} showSearch style={{ width: '90%' }} placeholder="请选择物流公司">
								{logisticsHtml}
							</Select>
						</div>
						<div>
							<Input type="text" value={sendData.logisticsCode} onChange={this.changeInputSendFn.bind(this, -1, 'logisticsCode')} style={{ width: '90%' }} placeholder="请输入物流单号" />
						</div>
					</div>
				</div>
			</Modal>
			<Modal
				visible={visibleApprove}
				title="订单审核"
				onOk={this.handleApproveOk.bind(this)}
				onCancel={this.handleApproveCancel.bind(this)}
				width = {'80%'}
				footer={[
            <Button key="back" size="large" onClick={self.handleApproveCancel.bind(this)}>取消</Button>,
            <Button key="submit" type="primary" size="large" loading={loadingApprove} onClick={self.handleApproveOk.bind(this)}>
              确认
            </Button>
          ]}
			>
				<div className="approve_modal">
					<label>审核意见</label>
					<div>
						<Switch checkedChildren="同意" unCheckedChildren="拒绝" onChange={this.changeApproveFn.bind(this, 'status')} checked={approveData.status?true:false} />
					</div>
				</div>
				<div className="approve_modal" style={{marginTop: '20px',display: approveData.status?'block':'none'}}>
					<label><span>*</span>收件人</label>
					<div>
						<Input placeholder="请输入收件人" value={approveData.receiver} onChange={this.changeApproveFn.bind(this, 'receiver')}/>
					</div>
				</div>
				<div className="approve_modal" style={{marginTop: '20px',display: approveData.status?'block':'none'}}>
					<label><span>*</span>联系电话</label>
					<div>
						<Input placeholder="请输入联系电话" value={approveData.mobile} onChange={this.changeApproveFn.bind(this, 'mobile')}/>
					</div>
				</div>
				<div className="approve_modal" style={{marginTop: '20px',display: approveData.status?'block':'none'}}>
					<label><span>*</span>所在地区</label>
					<div id="approveDivBox">
						<RegionCascader value={approveData.returnDelivery} onChange={this.changeApproveFn.bind(this, 'returnDelivery')} containerId="approveDivBox" placeholder="请选择所在地区" style={{ width: '100%' }}/>
					</div>
				</div>
				<div className="approve_modal" style={{marginTop: '20px',display: approveData.status?'block':'none'}}>
					<label><span>*</span>详细地址</label>
					<div>
						<Input placeholder="请输入详细地址" value={approveData.address} onChange={this.changeApproveFn.bind(this, 'address')}/>
					</div>
				</div>
				<div className="approve_modal" style={{marginTop: '20px'}}>
					<label>备注</label>
					<div>
						<Input.TextArea placeholder="请输入备注" value={approveData.remark} onChange={this.changeApproveFn.bind(this, 'remark')} autosize={{ minRows: 2, maxRows: 6 }} />
					</div>
				</div>
			</Modal>
			<Modal
				visible={visibleConfirmCollect}
				title="收货确认"
				onOk={this.handleConfirmCollectOk.bind(this)}
				onCancel={this.handleConfirmCollectCancel.bind(this)}
				width = {'80%'}
				footer={[
            <Button key="back" size="large" onClick={self.handleConfirmCollectCancel.bind(this)}>取消</Button>,
            <Button key="submit" type="primary" size="large" loading={loadingConfirmCollect} onClick={self.handleConfirmCollectOk.bind(this)}>
              确认
            </Button>
          ]}
			>
				<div className="approve_modal" style={{marginTop: '20px'}}>
					<label>仓库-货位<span>*</span></label>
					<div id="storageLocalConfirm">
						<Cascader getPopupContainer={() => document.getElementById('storageLocalConfirm')} value={confirmCollectData.warehouseArr} onChange={this.changeConfirmCollectFn.bind(this, 'warehouseArr')} options={this.state.warehouseList || []} placeholder="请选择仓库-货位" />
					</div>
				</div>
				<div className="approve_modal" style={{marginTop: '20px'}}>
					<label>待收数量</label>
					<div style={{paddingLeft: '88px'}}>
						{confirmCollectData.returnNum}
					</div>
				</div>
				<div className="approve_modal" style={{marginTop: '20px'}}>
					<label>实收数量<span>*</span></label>
					<div>
						<Input placeholder="请输入实收数量" type="number" value={confirmCollectData.deliveryNum} onChange={this.changeConfirmCollectFn.bind(this, 'deliveryNum')} />
					</div>
				</div>
				<div className="approve_modal" style={{marginTop: '20px'}}>
					<label>收货日期</label>
					<div>
						<DatePicker value={confirmCollectData.receiverDate ? moment(confirmCollectData.receiverDate, 'YYYY-MM-DD') : moment()} onChange={this.changeConfirmCollectFn.bind(this, 'receiverDate')} placeholder="请选择收货日期" />
					</div>
				</div>
			</Modal>
			<Modal
				title="退款确认"
				visible={this.state.returnAmountVisible}
				onOk={this.handleReturnAmountOk.bind(this)}
				onCancel={this.handleReturnAmountCancel.bind(this)}
			>
				<p>您确认已向{detailData.customerName}完成退款<span style={{color: '#d61518'}}>¥{detailData.amount}</span>，退款确认后订单即将关闭</p>
			</Modal>
		</div>
	}
}
;
export default returnOrderDetail;


// WEBPACK FOOTER //
// ./src/routes/returnOrder/detail.js